var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0H0V4.8H4.8V0Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 0H4.8V4.8H9.6V0Z",
    fill: "#252525"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 0H9.6V4.8H14.4V0Z",
    fill: "#252525"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 0H14.4V4.8H19.2V0Z",
    fill: "#252525"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H19.2V4.8H24V0Z",
    fill: "#252525"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0H24V4.8H28.8V0Z",
    fill: "#252525"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 0H28.8V4.8H33.6V0Z",
    fill: "#252525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 0H38.4V4.8H43.2V0Z",
    fill: "#252525"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48 0H43.2V4.8H48V0Z",
    fill: "#252525"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 0H48V4.8H52.8V0Z",
    fill: "#252525"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 0H52.8V4.8H57.6V0Z",
    fill: "#252525"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72 0H67.2V4.8H72V0Z",
    fill: "#252525"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 0H76.8V4.8H81.6V0Z",
    fill: "#252525"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 0H86.4V4.8H91.2V0Z",
    fill: "#252525"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M96 0H91.2V4.8H96V0Z",
    fill: "#252525"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 0H96V4.8H100.8V0Z",
    fill: "#252525"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 0H100.8V4.8H105.6V0Z",
    fill: "#252525"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 0H105.6V4.8H110.4V0Z",
    fill: "#252525"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 0H110.4V4.8H115.2V0Z",
    fill: "#252525"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H115.2V4.8H120V0Z",
    fill: "#252525"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 4.8H0V9.6H4.8V4.8Z",
    fill: "#252525"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 4.8H28.8L28.8 9.6H33.6V4.8Z",
    fill: "#252525"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48 4.8H43.2V9.6H48V4.8Z",
    fill: "#252525"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72 4.8H67.2V9.6H72V4.8Z",
    fill: "#252525"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 4.8H76.8V9.6H81.6V4.8Z",
    fill: "#252525"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 4.8H86.4V9.6H91.2V4.8Z",
    fill: "#252525"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M120 4.8H115.2V9.6H120V4.8Z",
    fill: "#252525"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 9.6H0V14.4H4.8V9.6Z",
    fill: "#252525"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 9.6H9.6V14.4H14.4V9.6Z",
    fill: "#252525"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 9.6H14.4V14.4H19.2V9.6Z",
    fill: "#252525"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9.6H19.2V14.4H24V9.6Z",
    fill: "#252525"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 9.6H28.8V14.4H33.6V9.6Z",
    fill: "#252525"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 9.6H38.4V14.4H43.2V9.6Z",
    fill: "#252525"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M48 9.6H43.2V14.4H48V9.6Z",
    fill: "#252525"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 9.6H48V14.4H52.8V9.6Z",
    fill: "#252525"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M72 9.6H67.2V14.4H72V9.6Z",
    fill: "#252525"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 9.6H86.4V14.4H91.2V9.6Z",
    fill: "#252525"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 9.6H96V14.4H100.8V9.6Z",
    fill: "#252525"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 9.6H100.8V14.4H105.6V9.6Z",
    fill: "#252525"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 9.6H105.6V14.4H110.4V9.6Z",
    fill: "#252525"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M120 9.6H115.2V14.4H120V9.6Z",
    fill: "#252525"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 14.4H0V19.2H4.8V14.4Z",
    fill: "#252525"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4H9.6V19.2H14.4V14.4Z",
    fill: "#252525"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 14.4H14.4V19.2H19.2V14.4Z",
    fill: "#252525"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.4H19.2V19.2H24V14.4Z",
    fill: "#252525"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 14.4H28.8V19.2H33.6V14.4Z",
    fill: "#252525"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 14.4H52.8V19.2H57.6V14.4Z",
    fill: "#252525"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 14.4H57.6V19.2H62.4V14.4Z",
    fill: "#252525"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 14.4H62.4V19.2H67.2V14.4Z",
    fill: "#252525"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14.4H67.2V19.2H72V14.4Z",
    fill: "#252525"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 14.4H72V19.2H76.8V14.4Z",
    fill: "#252525"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 14.4H86.4V19.2H91.2V14.4Z",
    fill: "#252525"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 14.4H96V19.2H100.8V14.4Z",
    fill: "#252525"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 14.4H100.8V19.2H105.6V14.4Z",
    fill: "#252525"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 14.4H105.6V19.2H110.4V14.4Z",
    fill: "#252525"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M120 14.4H115.2V19.2H120V14.4Z",
    fill: "#252525"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 19.2H0V24H4.8V19.2Z",
    fill: "#252525"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 19.2H9.6V24H14.4V19.2Z",
    fill: "#252525"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 19.2H14.4V24H19.2V19.2Z",
    fill: "#252525"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24 19.2H19.2V24H24V19.2Z",
    fill: "#252525"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 19.2H28.8V24H33.6V19.2Z",
    fill: "#252525"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 19.2H52.8V24H57.6V19.2Z",
    fill: "#252525"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 19.2H57.6V24H62.4V19.2Z",
    fill: "#252525"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 19.2H76.8V24H81.6V19.2Z",
    fill: "#252525"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 19.2H86.4V24H91.2V19.2Z",
    fill: "#252525"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 19.2H96V24H100.8V19.2Z",
    fill: "#252525"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 19.2H100.8V24H105.6V19.2Z",
    fill: "#252525"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 19.2H105.6V24H110.4V19.2Z",
    fill: "#252525"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M120 19.2H115.2V24H120V19.2Z",
    fill: "#252525"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 24H0V28.8H4.8V24Z",
    fill: "#252525"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 24H28.8V28.8H33.6V24Z",
    fill: "#252525"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24H43.2V28.8H48V24Z",
    fill: "#252525"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 24H72V28.8H76.8V24Z",
    fill: "#252525"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 24H76.8V28.8H81.6V24Z",
    fill: "#252525"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 24H86.4V28.8H91.2V24Z",
    fill: "#252525"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M120 24H115.2V28.8H120V24Z",
    fill: "#252525"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 28.8H0V33.6H4.8V28.8Z",
    fill: "#252525"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 28.8L4.8 28.8V33.6H9.6V28.8Z",
    fill: "#252525"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 28.8H9.6V33.6H14.4V28.8Z",
    fill: "#252525"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 28.8H14.4V33.6H19.2V28.8Z",
    fill: "#252525"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28.8H19.2V33.6H24V28.8Z",
    fill: "#252525"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 28.8L24 28.8V33.6H28.8L28.8 28.8Z",
    fill: "#252525"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 28.8H28.8L28.8 33.6H33.6V28.8Z",
    fill: "#252525"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 28.8L38.4 28.8V33.6H43.2V28.8Z",
    fill: "#252525"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 28.8L48 28.8V33.6H52.8V28.8Z",
    fill: "#252525"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 28.8H57.6V33.6H62.4V28.8Z",
    fill: "#252525"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28.8L67.2 28.8V33.6H72L72 28.8Z",
    fill: "#252525"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 28.8H76.8V33.6H81.6V28.8Z",
    fill: "#252525"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 28.8H86.4V33.6H91.2V28.8Z",
    fill: "#252525"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28.8L91.2 28.8V33.6H96V28.8Z",
    fill: "#252525"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 28.8H96V33.6H100.8V28.8Z",
    fill: "#252525"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 28.8H100.8V33.6H105.6V28.8Z",
    fill: "#252525"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 28.8H105.6V33.6H110.4V28.8Z",
    fill: "#252525"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 28.8L110.4 28.8V33.6H115.2V28.8Z",
    fill: "#252525"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M120 28.8H115.2V33.6H120V28.8Z",
    fill: "#252525"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 33.6H38.4V38.4H43.2V33.6Z",
    fill: "#252525"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 33.6H48V38.4H52.8V33.6Z",
    fill: "#252525"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 33.6H57.6V38.4H62.4V33.6Z",
    fill: "#252525"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 33.6H62.4V38.4H67.2V33.6Z",
    fill: "#252525"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M72 33.6H67.2V38.4H72V33.6Z",
    fill: "#252525"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 38.4H0V43.2H4.8V38.4Z",
    fill: "#252525"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 38.4H9.6V43.2H14.4V38.4Z",
    fill: "#252525"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 38.4H24V43.2H28.8V38.4Z",
    fill: "#252525"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 38.4H28.8V43.2H33.6V38.4Z",
    fill: "#252525"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 38.4H62.4V43.2H67.2V38.4Z",
    fill: "#252525"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 38.4H81.6V43.2H86.4V38.4Z",
    fill: "#252525"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 38.4H86.4V43.2H91.2V38.4Z",
    fill: "#252525"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 38.4H105.6V43.2H110.4V38.4Z",
    fill: "#252525"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M120 38.4H115.2V43.2H120V38.4Z",
    fill: "#252525"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 43.2H0V48H4.8V43.2Z",
    fill: "#252525"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 43.2H33.6V48H38.4V43.2Z",
    fill: "#252525"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43.2H43.2V48H48V43.2Z",
    fill: "#252525"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 43.2H48V48H52.8V43.2Z",
    fill: "#252525"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 43.2H52.8V48H57.6V43.2Z",
    fill: "#252525"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 43.2H57.6V48H62.4V43.2Z",
    fill: "#252525"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 43.2H62.4V48H67.2V43.2Z",
    fill: "#252525"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 43.2H76.8V48H81.6V43.2Z",
    fill: "#252525"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 43.2H81.6V48H86.4V43.2Z",
    fill: "#252525"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 43.2H86.4V48H91.2V43.2Z",
    fill: "#252525"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43.2H91.2V48H96V43.2Z",
    fill: "#252525"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 43.2H96V48H100.8V43.2Z",
    fill: "#252525"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 43.2H110.4V48H115.2V43.2Z",
    fill: "#252525"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M120 43.2H115.2V48H120V43.2Z",
    fill: "#252525"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 48H9.6V52.8H14.4V48Z",
    fill: "#252525"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 48H14.4V52.8H19.2V48Z",
    fill: "#252525"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48H19.2V52.8H24V48Z",
    fill: "#252525"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 48H28.8V52.8H33.6V48Z",
    fill: "#252525"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 48H48V52.8H52.8V48Z",
    fill: "#252525"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 48H57.6V52.8H62.4V48Z",
    fill: "#252525"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 48H62.4V52.8H67.2V48Z",
    fill: "#252525"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 48H76.8V52.8H81.6V48Z",
    fill: "#252525"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 48H81.6V52.8H86.4V48Z",
    fill: "#252525"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48H91.2V52.8H96V48Z",
    fill: "#252525"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 48H100.8V52.8H105.6V48Z",
    fill: "#252525"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 48H105.6V52.8H110.4V48Z",
    fill: "#252525"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M120 48H115.2V52.8H120V48Z",
    fill: "#252525"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 52.8H0V57.6H4.8V52.8Z",
    fill: "#252525"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 52.8H9.6V57.6H14.4V52.8Z",
    fill: "#252525"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52.8H19.2V57.6H24V52.8Z",
    fill: "#252525"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 52.8H38.4V57.6H43.2V52.8Z",
    fill: "#252525"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52.8H43.2V57.6H48V52.8Z",
    fill: "#252525"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 52.8H48V57.6H52.8V52.8Z",
    fill: "#252525"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 52.8H72V57.6H76.8V52.8Z",
    fill: "#252525"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 52.8H86.4V57.6H91.2V52.8Z",
    fill: "#252525"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 52.8H96V57.6H100.8V52.8Z",
    fill: "#252525"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 52.8H110.4V57.6H115.2V52.8Z",
    fill: "#252525"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 57.6H4.8V62.4H9.6V57.6Z",
    fill: "#252525"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 57.6H9.6V62.4H14.4V57.6Z",
    fill: "#252525"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 57.6H24V62.4H28.8V57.6Z",
    fill: "#252525"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 57.6H28.8V62.4H33.6V57.6Z",
    fill: "#252525"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 57.6H33.6V62.4H38.4V57.6Z",
    fill: "#252525"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 57.6H38.4V62.4H43.2V57.6Z",
    fill: "#252525"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57.6H43.2V62.4H48V57.6Z",
    fill: "#252525"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 57.6H48V62.4H52.8V57.6Z",
    fill: "#252525"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 57.6H57.6V62.4H62.4V57.6Z",
    fill: "#252525"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 57.6H62.4V62.4H67.2V57.6Z",
    fill: "#252525"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M72 57.6H67.2V62.4H72L72 57.6Z",
    fill: "#252525"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 57.6H72L72 62.4H76.8V57.6Z",
    fill: "#252525"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 57.6H96V62.4H100.8V57.6Z",
    fill: "#252525"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 57.6H100.8V62.4H105.6V57.6Z",
    fill: "#252525"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 57.6H105.6V62.4H110.4V57.6Z",
    fill: "#252525"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 57.6H110.4V62.4H115.2V57.6Z",
    fill: "#252525"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 62.4H4.8V67.2H9.6V62.4Z",
    fill: "#252525"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M24 62.4H19.2V67.2H24V62.4Z",
    fill: "#252525"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 62.4H38.4V67.2H43.2V62.4Z",
    fill: "#252525"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M48 62.4H43.2V67.2H48V62.4Z",
    fill: "#252525"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 62.4H52.8V67.2H57.6V62.4Z",
    fill: "#252525"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 62.4H57.6V67.2H62.4V62.4Z",
    fill: "#252525"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M72 62.4H67.2V67.2H72V62.4Z",
    fill: "#252525"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 62.4H76.8V67.2H81.6V62.4Z",
    fill: "#252525"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 62.4H81.6V67.2H86.4V62.4Z",
    fill: "#252525"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M96 62.4H91.2V67.2H96V62.4Z",
    fill: "#252525"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 62.4H96V67.2H100.8V62.4Z",
    fill: "#252525"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 62.4H105.6V67.2H110.4V62.4Z",
    fill: "#252525"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M120 62.4H115.2V67.2H120V62.4Z",
    fill: "#252525"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 67.2H0V72H4.8V67.2Z",
    fill: "#252525"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 67.2H4.8V72H9.6V67.2Z",
    fill: "#252525"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 67.2H9.6V72H14.4V67.2Z",
    fill: "#252525"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 67.2H14.4V72H19.2V67.2Z",
    fill: "#252525"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M24 67.2H19.2V72H24V67.2Z",
    fill: "#252525"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 67.2H28.8V72H33.6V67.2Z",
    fill: "#252525"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4 67.2H33.6V72H38.4V67.2Z",
    fill: "#252525"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 67.2H38.4V72H43.2V67.2Z",
    fill: "#252525"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67.2H43.2V72H48V67.2Z",
    fill: "#252525"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67.2H67.2V72H72V67.2Z",
    fill: "#252525"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 67.2H72V72H76.8V67.2Z",
    fill: "#252525"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 67.2H76.8V72H81.6V67.2Z",
    fill: "#252525"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 67.2H81.6V72H86.4V67.2Z",
    fill: "#252525"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 67.2H105.6V72H110.4V67.2Z",
    fill: "#252525"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 67.2H110.4V72H115.2V67.2Z",
    fill: "#252525"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M120 67.2H115.2V72H120V67.2Z",
    fill: "#252525"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 72H0V76.8H4.8V72Z",
    fill: "#252525"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 72H9.6V76.8H14.4V72Z",
    fill: "#252525"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 72L48 72V76.8H52.8V72Z",
    fill: "#252525"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 72H52.8V76.8H57.6V72Z",
    fill: "#252525"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 72H57.6V76.8H62.4V72Z",
    fill: "#252525"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72H67.2V76.8H72V72Z",
    fill: "#252525"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M96 72H91.2V76.8H96V72Z",
    fill: "#252525"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 72H96V76.8H100.8V72Z",
    fill: "#252525"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 72L100.8 72V76.8H105.6V72Z",
    fill: "#252525"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M120 72H115.2V76.8H120V72Z",
    fill: "#252525"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 76.8H0V81.6H4.8V76.8Z",
    fill: "#252525"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 76.8H9.6V81.6H14.4V76.8Z",
    fill: "#252525"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 76.8H14.4V81.6H19.2V76.8Z",
    fill: "#252525"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M24 76.8H19.2V81.6H24V76.8Z",
    fill: "#252525"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 76.8H24V81.6H28.8V76.8Z",
    fill: "#252525"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 76.8H28.8V81.6H33.6V76.8Z",
    fill: "#252525"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 76.8H38.4V81.6H43.2V76.8Z",
    fill: "#252525"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M48 76.8H43.2V81.6H48V76.8Z",
    fill: "#252525"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 76.8H52.8V81.6H57.6V76.8Z",
    fill: "#252525"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 76.8H57.6V81.6H62.4V76.8Z",
    fill: "#252525"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 76.8H62.4V81.6H67.2V76.8Z",
    fill: "#252525"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 76.8H72L72 81.6H76.8V76.8Z",
    fill: "#252525"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 76.8H76.8V81.6H81.6V76.8Z",
    fill: "#252525"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 76.8H81.6V81.6H86.4V76.8Z",
    fill: "#252525"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 76.8H86.4V81.6H91.2V76.8Z",
    fill: "#252525"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M96 76.8H91.2V81.6H96V76.8Z",
    fill: "#252525"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 76.8H96V81.6H100.8V76.8Z",
    fill: "#252525"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 76.8H100.8V81.6H105.6V76.8Z",
    fill: "#252525"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 76.8H110.4V81.6H115.2V76.8Z",
    fill: "#252525"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M120 76.8H115.2V81.6H120V76.8Z",
    fill: "#252525"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 81.6H76.8V86.4H81.6V81.6Z",
    fill: "#252525"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 81.6H96V86.4H100.8V81.6Z",
    fill: "#252525"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 81.6H100.8V86.4H105.6V81.6Z",
    fill: "#252525"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 86.4H0V91.2H4.8V86.4Z",
    fill: "#252525"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 86.4H4.8V91.2H9.6V86.4Z",
    fill: "#252525"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 86.4H9.6V91.2H14.4V86.4Z",
    fill: "#252525"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 86.4H14.4V91.2H19.2V86.4Z",
    fill: "#252525"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M24 86.4H19.2V91.2H24V86.4Z",
    fill: "#252525"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 86.4H24V91.2H28.8V86.4Z",
    fill: "#252525"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 86.4H28.8V91.2H33.6V86.4Z",
    fill: "#252525"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86.4H43.2V91.2H48V86.4Z",
    fill: "#252525"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 86.4H52.8V91.2H57.6V86.4Z",
    fill: "#252525"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 86.4H57.6V91.2H62.4V86.4Z",
    fill: "#252525"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 86.4H62.4V91.2H67.2V86.4Z",
    fill: "#252525"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 86.4H76.8V91.2H81.6V86.4Z",
    fill: "#252525"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 86.4H86.4V91.2H91.2V86.4Z",
    fill: "#252525"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 86.4H96V91.2H100.8V86.4Z",
    fill: "#252525"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 86.4H110.4V91.2H115.2V86.4Z",
    fill: "#252525"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M120 86.4H115.2V91.2H120V86.4Z",
    fill: "#252525"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 91.2H0V96H4.8V91.2Z",
    fill: "#252525"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 91.2H28.8L28.8 96H33.6V91.2Z",
    fill: "#252525"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 91.2H38.4V96H43.2V91.2Z",
    fill: "#252525"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 91.2H48V96H52.8V91.2Z",
    fill: "#252525"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 91.2H52.8V96H57.6V91.2Z",
    fill: "#252525"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 91.2H62.4V96H67.2V91.2Z",
    fill: "#252525"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 91.2H72V96H76.8V91.2Z",
    fill: "#252525"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 91.2H76.8V96H81.6V91.2Z",
    fill: "#252525"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 91.2H96V96H100.8V91.2Z",
    fill: "#252525"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 91.2H105.6V96H110.4V91.2Z",
    fill: "#252525"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 91.2H110.4V96H115.2V91.2Z",
    fill: "#252525"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 96H0V100.8H4.8V96Z",
    fill: "#252525"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 96H9.6V100.8H14.4V96Z",
    fill: "#252525"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 96H14.4V100.8H19.2V96Z",
    fill: "#252525"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M24 96H19.2V100.8H24V96Z",
    fill: "#252525"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 96H28.8V100.8H33.6V96Z",
    fill: "#252525"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 96H48V100.8H52.8V96Z",
    fill: "#252525"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 96H72V100.8H76.8V96Z",
    fill: "#252525"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 96H76.8V100.8H81.6V96Z",
    fill: "#252525"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 96H81.6V100.8H86.4V96Z",
    fill: "#252525"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 96H86.4V100.8H91.2V96Z",
    fill: "#252525"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M96 96H91.2V100.8H96V96Z",
    fill: "#252525"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 96H96V100.8H100.8V96Z",
    fill: "#252525"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 96H100.8V100.8H105.6V96Z",
    fill: "#252525"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 96H105.6V100.8H110.4V96Z",
    fill: "#252525"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M115.2 96H110.4V100.8H115.2V96Z",
    fill: "#252525"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 100.8H0V105.6H4.8V100.8Z",
    fill: "#252525"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 100.8H9.6V105.6H14.4V100.8Z",
    fill: "#252525"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 100.8H14.4V105.6H19.2V100.8Z",
    fill: "#252525"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M24 100.8H19.2V105.6H24V100.8Z",
    fill: "#252525"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 100.8H28.8V105.6H33.6V100.8Z",
    fill: "#252525"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100.8H43.2V105.6H48V100.8Z",
    fill: "#252525"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 100.8H48V105.6H52.8V100.8Z",
    fill: "#252525"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6 100.8H52.8V105.6H57.6V100.8Z",
    fill: "#252525"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M72 100.8H67.2V105.6H72L72 100.8Z",
    fill: "#252525"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 100.8H72L72 105.6H76.8V100.8Z",
    fill: "#252525"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 100.8H105.6V105.6H110.4V100.8Z",
    fill: "#252525"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M120 100.8H115.2V105.6H120V100.8Z",
    fill: "#252525"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 105.6H0V110.4H4.8V105.6Z",
    fill: "#252525"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 105.6H9.6V110.4H14.4V105.6Z",
    fill: "#252525"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 105.6H14.4V110.4H19.2V105.6Z",
    fill: "#252525"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M24 105.6H19.2V110.4H24V105.6Z",
    fill: "#252525"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 105.6H28.8V110.4H33.6V105.6Z",
    fill: "#252525"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 105.6H38.4V110.4H43.2V105.6Z",
    fill: "#252525"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 105.6H48V110.4H52.8V105.6Z",
    fill: "#252525"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105.6H67.2V110.4H72V105.6Z",
    fill: "#252525"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 105.6H100.8V110.4H105.6V105.6Z",
    fill: "#252525"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 110.4H0V115.2H4.8V110.4Z",
    fill: "#252525"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 110.4H28.8V115.2H33.6V110.4Z",
    fill: "#252525"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M48 110.4H43.2V115.2H48V110.4Z",
    fill: "#252525"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 110.4H62.4V115.2H67.2V110.4Z",
    fill: "#252525"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6 110.4H76.8V115.2H81.6V110.4Z",
    fill: "#252525"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M96 110.4H91.2V115.2H96V110.4Z",
    fill: "#252525"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 110.4H96V115.2H100.8V110.4Z",
    fill: "#252525"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M105.6 110.4H100.8V115.2H105.6V110.4Z",
    fill: "#252525"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 110.4H105.6V115.2H110.4V110.4Z",
    fill: "#252525"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8 115.2H0V120H4.8V115.2Z",
    fill: "#252525"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6 115.2H4.8V120H9.6V115.2Z",
    fill: "#252525"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 115.2H9.6V120H14.4V115.2Z",
    fill: "#252525"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 115.2H14.4V120H19.2V115.2Z",
    fill: "#252525"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M24 115.2H19.2V120H24V115.2Z",
    fill: "#252525"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 115.2H24V120H28.8L28.8 115.2Z",
    fill: "#252525"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 115.2H28.8L28.8 120H33.6V115.2Z",
    fill: "#252525"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 115.2H38.4V120H43.2V115.2Z",
    fill: "#252525"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M48 115.2H43.2V120H48V115.2Z",
    fill: "#252525"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8 115.2H48V120H52.8V115.2Z",
    fill: "#252525"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4 115.2H57.6V120H62.4V115.2Z",
    fill: "#252525"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 115.2H62.4V120H67.2V115.2Z",
    fill: "#252525"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M72 115.2H67.2V120H72V115.2Z",
    fill: "#252525"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 115.2H81.6V120H86.4V115.2Z",
    fill: "#252525"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2 115.2H86.4V120H91.2V115.2Z",
    fill: "#252525"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M100.8 115.2H96V120H100.8V115.2Z",
    fill: "#252525"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M110.4 115.2H105.6V120H110.4V115.2Z",
    fill: "#252525"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M120 115.2H115.2V120H120V115.2Z",
    fill: "#252525"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.5576e52dca2809c582e26a8840e3f437.svg";
export { ForwardRef as ReactComponent };